// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"BottomNavigation_bottomNav__ENhSq"};